import { NewVodData } from '@/shared/types/services/types/vodService/IVodServiceStreamIQ'
import { VodItemProps } from '@/types/vod/VodItem'
import placeholder from '@/shared/assets/images/placeholderPoster.webp'

export function mapNewVodDataToVodItemProps(
    data: NewVodData,
    isCardOrientationPriorityHorizontal?: boolean
): VodItemProps {
    const landscapeImage = data.images.find(
        (image) => image.orientation === 'landscape' && image.size === 'large'
    )

    const portraitImage = data.images.find(
        (image) => image.orientation === 'portrait' && image.size === 'medium'
    )

    const image = isCardOrientationPriorityHorizontal
        ? portraitImage
        : landscapeImage

    return {
        id: data.id,
        title: data.title,
        // description: data.description,
        aspectRatio: data.images.find((img) => img.orientation === 'landscape')
            ? '16:9'
            : '2:3',
        productType: data.type,
        type: data.type,
        imageUrl:
            // (channelImage && channelImage.url) ||
            (image && image.url) || data.images[0].url || placeholder,
        productId: data.id,
        externalUri: undefined,
        shouldAuthenticateLinkUri: false,
        showDetails: true,
        apiEpochTime: new Date(data.releaseDate).getTime(),
        label: {
            imageUrl: '',
            text: data.tags[0],
            textColor: '',
            textBackgroundColor: '',
        },
        ord: 0,
        position: 0,
        duration: data.runtime * 60 * 1000,
        serviceName: data.serviceName,
        channelId: data.channelId,
    }
}
